import { Action } from '@ngrx/store';
import { ILocationConfigUnit } from '../../models/location-config.interface';
import { PurchaseOrderAsyncErrors } from '@ordersnproducts/modules/order-builder/modules/location/models/purchase-order-async-errors';

export const SET = '[Purchase order] Set';
export const VALIDATE_START = '[Purchase order] Validate start';
export const VALIDATE_END = '[Purchase order] Validate end';
export const LOAD_INITIAL_STATE = '[Purchase order] load initial state';
export const MANDATORY = '[Purchase order] is needed';
export const SET_PURCHASE_ORDER_ASYNC_ERRORS = '[Purchase Order] Set purchase order async errors';
export const VALIDATION_ENDED = '[Purchase Order] Validation Ended';
export const SET_VALID_PO_MASKS = '[Purchase Order] Set valid PO masks';
export const RESET_MASKS_FETCH = '[Purchase Order] Reset masks fetch';

export class PurchaseOrderLoadInitialState implements Action {
  readonly type = LOAD_INITIAL_STATE;

  constructor(public payload: ILocationConfigUnit) {}
}

export class PurchaseOrderMandatoryAction implements Action {
  readonly type = MANDATORY;

  constructor(public payload: boolean) {}
}

export class PurchaseOrderSetAction implements Action {
  readonly type = SET;

  constructor(public payload: string) {}
}

export class PurchaseOrderValidateStartAction implements Action {
  readonly type = VALIDATE_START;
  readonly payload: any;
  constructor() {}
}

export class PurchaseOrderValidateEndAction implements Action {
  readonly type = VALIDATE_END;
  readonly payload: any;
  constructor() {}
}

export class SetPurchaseOrderAsyncErrorsAction implements Action {
  readonly type = SET_PURCHASE_ORDER_ASYNC_ERRORS;
  constructor(public payload: PurchaseOrderAsyncErrors) {}
}

export class ValidationEndedAction implements Action {
  readonly type = VALIDATION_ENDED;
  constructor() {}
}

export class SetValidPOMasks implements Action {
  readonly type = SET_VALID_PO_MASKS;
  constructor(public payload: string[]) {}
}

export class ResetMasksFetchAction implements Action {
  readonly type = RESET_MASKS_FETCH;
  constructor() {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type PurchaseOrderActions =
  | PurchaseOrderSetAction
  | PurchaseOrderMandatoryAction
  | PurchaseOrderLoadInitialState
  | PurchaseOrderValidateStartAction
  | PurchaseOrderValidateEndAction
  | SetPurchaseOrderAsyncErrorsAction
  | ValidationEndedAction
  | SetValidPOMasks
  | ResetMasksFetchAction;
